const SIMPLE_URL = 'https://www.wix.com/';
export const DEFAULT_TEMPLATE = 'sch';

// https://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative
const isAbsoluteUrlReg = new RegExp('^(?:[a-z+]+:)?//', 'i');
export const safeConcatUrl = _ref => {
  let {
    baseUrl,
    pathname
  } = _ref;
  return `${(baseUrl ?? '').replace(/\/$/, '')}/${(pathname ?? '').replace(/^\//, '')}`;
};
export const createAnywhereUrl = async _ref2 => {
  let {
    url,
    baseUrl,
    settingsId,
    template = DEFAULT_TEMPLATE
  } = _ref2;
  return createAnywhereUrlSync({
    url,
    baseUrl,
    template,
    settingsId
  });
};
export const createAnywhereUrlSync = _ref3 => {
  let {
    url,
    baseUrl,
    settingsId,
    template = DEFAULT_TEMPLATE
  } = _ref3;
  const isAbsoluteUrl = isAbsoluteUrlReg.test(url);
  const baseUrlWithTrailingSlash = baseUrl.replace(/\/$/, '') + '/';
  const urlNoPathParamsFromBaseUrl = new URL((baseUrl === url || url === '' || url === '/' // home page
  ? baseUrlWithTrailingSlash : isAbsoluteUrl ? url : safeConcatUrl({
    baseUrl,
    pathname: url
  })).replace(baseUrlWithTrailingSlash, SIMPLE_URL));
  urlNoPathParamsFromBaseUrl.pathname = `/_api/dayful/${template}/route${urlNoPathParamsFromBaseUrl.pathname ?? ''}`;
  if (settingsId) {
    urlNoPathParamsFromBaseUrl.searchParams.set('anywhereThemeOverrideId', settingsId);
  }
  return urlNoPathParamsFromBaseUrl.toString().replace(SIMPLE_URL, baseUrlWithTrailingSlash);
};
export const bulkCreateAnywhereUrl = async _ref4 => {
  let {
    urls,
    baseUrl,
    template = DEFAULT_TEMPLATE
  } = _ref4;
  return Promise.all(urls.map(url => createAnywhereUrl({
    url,
    baseUrl,
    template
  })));
};
export const isAnywhereUrl = async _ref5 => {
  var _baseUrl$pathname;
  let {
    fullUrl,
    externalBaseUrl
  } = _ref5;
  let url;
  let baseUrl;
  try {
    url = new URL(fullUrl);
    baseUrl = new URL(externalBaseUrl);
  } catch (e) {
    console.error('Failed to convert fullUrl/externalBaseUrl - make sure they are both full URLs ', {
      fullUrl,
      externalBaseUrl
    }, e);
    throw e;
  }
  return url.searchParams.has('dayful') || /\/_api\/dayful\/\w+\/route/.test(url.pathname) || ((_baseUrl$pathname = baseUrl.pathname) == null || (_baseUrl$pathname = _baseUrl$pathname.split('/')) == null || (_baseUrl$pathname = _baseUrl$pathname.filter(part => !!part)) == null || (_baseUrl$pathname = _baseUrl$pathname.pop()) == null ? void 0 : _baseUrl$pathname.startsWith('dayful_'));
};
//# sourceMappingURL=wix-anywhere-url.js.map